<template>
    <!-- 介绍 -->
    <div class="introduce" :class="$IsMobile ? 'moblie' : ''">
        <div class="cBlock mt25">
            <div class="tit"><h5>公司介绍</h5></div>
            <div class="cTxt">
                <div class="ql-container ql-snow" v-if="!$IsMobile">
                    <div class="ql-editor">
                        <div class="details_box" v-html="enterpriseInfo.introduction"></div>
                    </div>
                </div>
                <text-expansion v-else :data="enterpriseInfo.introduction"></text-expansion>
                <el-carousel height="350px" style="width: 100%" type="card" v-if="!$IsMobile && photo && photo.length">
                    <el-carousel-item v-for="item in photo" :key="item">
                        <el-image style="height: 350px;" :src="'/files?imagePath=' + item" alt=""></el-image>
                    </el-carousel-item>
                </el-carousel>
                <el-carousel height="250px" style="width: 100%" v-if="$IsMobile && photo && photo.length">
                    <el-carousel-item v-for="item in photo" :key="item">
                        <el-image style="height: 250px;" :src="'/files?imagePath=' + item" alt=""></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <div class="cBlock mt25">
            <div class="tit"><h5>公司地址</h5></div>
            <div class="cTxt" v-if="showMap">
                <p><i class="el-icon-location"></i>{{ address }}</p>
                <baidu-map class="baiduMap" @ready="handler" :scroll-wheel-zoom="true"></baidu-map>
            </div>
        </div>
        <div class="cBlock recruitment mt25">
            <div class="tit"><h5>在招职位</h5></div>
            <div :class="{ cTxt: !$IsMobile }">
                <common-search v-if="!$IsMobile" @search="handleSearch"></common-search>
                <common-list :jobPositionList="jobPositionList" :searchParams="searchParams" :page="page"
                             @pageNumber="handlePageChange"></common-list>
            </div>
        </div>
    </div>
</template>

<script>
    import CommonSearch from "./CommonSearch";
    import CommonList from "./CommonList";
    import TextExpansion from "@/components/TextExpansion.vue";

    export default {
        props: ["enterpriseInfo"],
        data() {
            return {
                showMap: false,
                address: "",
                company: "泰迪科技",
                jobPositionList: [],
                searchParams: {
                    pageNumber: 1,
                    pageSize: 10,
                    status: 1, //已发布
                    keyword: "", //关键字
                    willNature: "", // 工作性质（实习，兼职，全职）
                    wageList: [], //
                },
                page: {
                    totalElements: 0,
                },
                interval: null,
            };
        },
        computed: {
            photo() {
                try {
                    return JSON.parse(this.enterpriseInfo.photo);
                } catch (e) {
                    return [];
                }
            },
        },
        updated() {
            this.getRegionCode().then((regionDict) => {
                let address = this.formatterRegionCode(
                    regionDict,
                    this.enterpriseInfo.enterpriseAddress
                );
                address += this.enterpriseInfo.enterpriseAddress.detailedAddress;
                this.address = address;
                this.showMap = true;
            });
        },
        mounted() {
            this.interval = setInterval(() => {
                if (this.enterpriseInfo.enterpriseId) {
                    this.getPositionList(this.searchParams);
                    clearInterval(this.interval);
                }
            }, 500);
        },
        methods: {
            //所有职位查询
            handleSearch(params) {
                this.searchParams.keyword = params.keyword;
                this.searchParams.wageList = params.wageList;
                this.searchParams.willNature = params.willNature;
                this.getPositionList(this.searchParams);
            },
            //所有职位翻页
            handlePageChange(number) {
                this.searchParams.pageNumber = number;
                this.getPositionList(this.searchParams);
            },
            //获取所有职位列表
            getPositionList(params) {
                params["enterpriseId"] = this.enterpriseInfo.enterpriseId;
                params["deadlineFilter"] = true;
                this.$store.dispatch("global/getJobPositionList", params).then((res) => {
                    this.page.totalElements = parseInt(res.data.totalElements);
                    this.jobPositionList = res.data.content;
                });
            },
            handler({BMap, map}) {
                map.centerAndZoom(this.address, 13);
                let local = new BMap.LocalSearch(map, {
                    //智能搜索
                    onSearchComplete: () => {
                        let pp = local.getResults().getPoi(0).point; // 获取第一个智能搜索的结果
                        map.centerAndZoom(pp, 18);
                        map.addOverlay(new BMap.Marker(pp)); // 添加标注
                    },
                });
                local.search(this.address);
                let circle = new BMap.Circle(null, 6, {
                    strokeColor: "Red",
                    strokeWeight: 6,
                    strokeOpacity: 1,
                    Color: "Red",
                    fillColor: "#f03",
                });
                map.addOverlay(circle);
            },
        },
        components: {
            CommonSearch,
            CommonList,
            TextExpansion,
        },
    };
</script>
<style lang="scss">
    .introduce.moblie {
        .cBlock {
            margin-top: 0px;
            padding: 15px 0 18px 0;
            margin-bottom: 12px;

            .tit h5 {
                padding-left: 12px;
                font-size: 16px;

                &::before {
                    width: 2px;
                }
            }

            .cTxt {
                padding: 15px 12px 0 12px;
                line-height: 22px;
            }

            .baiduMap {
                height: 200px;
            }
        }

        .cBlock.recruitment {
            background: transparent;
        }
    }

    .ql-container.ql-snow {
        border: none;
    }
</style>
